import { ReactElement } from "react";
import Message from "./Message";
import { MessageVariant } from "src/shared/enums/messageTypes/messageTypes";

type TChipMessageProps = {
  message: string | ReactElement;
  variant: MessageVariant;
  boldWord?: string;
  closable?: boolean;
};

function ChipMessage(props: TChipMessageProps) {
  const { message, variant, boldWord, closable = false } = props;
  let bgColor: string;
  switch (variant) {
    case MessageVariant.Info:
      bgColor = "#90CAF9";
      break;
    case MessageVariant.InfoLight:
      bgColor = "#42A5F5";
      break;
    case MessageVariant.Warning:
      bgColor = "#ED6C01";
      break;
    case MessageVariant.WarningLight:
      bgColor = "#FFA726";
      break;
    case MessageVariant.Error:
      bgColor = "#D32F2E";
      break;
    case MessageVariant.ErrorLight:
      bgColor = "#E53935";
      break;
    case MessageVariant.ErrorPending:
      bgColor = "#EF5350";
      break;
    case MessageVariant.Success:
      bgColor = "#2D7D31";
      break;
    case MessageVariant.Neutral:
      bgColor = "#9E9E9E";
      break;
    case MessageVariant.Draft:
      bgColor = "#B0BEC5";
      break;
    case MessageVariant.WarningDark:
      bgColor = "#88441e";
      break;
    case MessageVariant.Deleted:
      bgColor = "#666666";
      break;
    case MessageVariant.Purple:
      bgColor = "#9a47af";
      break;
    default:
      bgColor = "#90CAF9";
      break;
  }
  return (
    <Message
      message={message}
      boldWord={boldWord}
      closable={closable}
      bgColor={bgColor}
      textColor={"#ffffff"}
      borderRadius={"2rem"}
      textAlign={"center"}
      fontSize={".8rem"}
      mb={0}
    />
  );
}

export default ChipMessage;
